import ApiService, { HttpMethod } from "../../commons/api/api_service";
import BaseResponse from "../../commons/api/base_response";
import { Endpoints } from "../../commons/api/endpoints";
import ViewModelV2 from "../../commons/base/v2/view_model";
import {
    AllLocationStock,
    AllLocationStockResponseBody,
} from "../models/all_outlet_stock_dashboard_models";

export default class AllOutletStockDashboardVM extends ViewModelV2 {
    data: AllLocationStock[] = [];
    filteredData: AllLocationStock[] = [];
    isLoading = true;
    errorMessage = "";
    byMatCodeFilters: string[] = [];
    isModalOpen = false;

    selection = new Map<string, string>();
    selected = new Map<string, string>();

    constructor() {
        super();
        this.loadData();
    }

    loadData() {
        this.emit(() => {
            this.isLoading = true;
        });

        ApiService.fetch<{}, BaseResponse<typeof AllLocationStockResponseBody>>(
            Endpoints.getAllOutletStock,
            {
                httpMethod: HttpMethod.get,
                onSuccess: (response) => {
                    if (response) {
                        this.emit(() => {
                            this.isLoading = false;
                            this.data = response.data ?? [];
                            this.data = this.data.map((data) => {
                                data.items = data.items.filter((item) => item.qty >= 0.01);
                                return data;
                            });
                            
                            // sort by location name alphabetically
                            this.data = this.data.sort((A, B) => 
                                A.location.name.localeCompare(B.location.name));
                            
                            // create new filtered data
                            this.filteredData = this.data;
                            
                            // create a list of available items / selection of items
                            this.data.forEach((data) => {
                                data.items.forEach((item) => {
                                    this.selection.set(item.matCode, item.name);
                                });
                            });
                        });
                    }
                },
                onFailure: (error, code) => {
                    this.emit(() => {
                        this.isLoading = false;
                        this.errorMessage = error;
                    });
                },
            }
        );
    }

    filterByMatCode() {
        this.emit(() => {
            this.filteredData = [];
            this.data.forEach((data) => {
                const clonedData: AllLocationStock = {
                    // clone items while filtering
                    items: data.items.filter((item) => {
                        const match = this.byMatCodeFilters.filter((el) => el === item.matCode);
                        if (match.length > 0) return true;
                        else return false;
                    }),
                    location: {...data.location}
                }
                this.filteredData.push(clonedData);
            });
        });
    }

    handleOpen() {
        this.emit(() => {
            this.isModalOpen = true;
        });
    }

    handleClose() {
        this.emit(() => {
            this.isModalOpen = false;
        });
    }

    handleItemSelectionSave(matCode: string, name: string) {
        this.emit(() => {
            this.selected.set(matCode, name);
        });
    }
    
    applyFilter() {
        this.byMatCodeFilters = [];
        this.selected.forEach((name, matCode) => {
            this.byMatCodeFilters.push(matCode);
        });
        this.emit(() => {
            this.isModalOpen = false;
            if (this.byMatCodeFilters.length === 0)
                this.filteredData = this.data;
            else
                this.filterByMatCode();
        });
    }

    deleteFilter(matCode: string) {
        this.emit(() => {
            this.selected.delete(matCode);
            this.byMatCodeFilters.splice(this.byMatCodeFilters.indexOf(matCode), 1);
        });
    }
}
